(() => {
  const blocks = Array.from(document.querySelectorAll('[data-bundle-toggle]'));
  if (!blocks.length) return;

  blocks.forEach((toggle) => {
    const section = toggle.closest('.featured-bundle');
    if (!section) return;

    const dataEl = section.querySelector('[data-selling-plans]');
    const priceEl = section.querySelector('[data-bundle-price]');
    const sellingPlanInput = section.querySelector('[data-selling-plan-input]');
    if (!dataEl || !priceEl || !sellingPlanInput) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent || '{}');
    } catch {
      return;
    }

    const buttons = Array.from(toggle.querySelectorAll('[data-bundle-toggle-option]'));
    if (!buttons.length) return;

    const formatMoney = (cents) => {
      // Keep it simple: rely on Shopify-rendered initial string when possible.
      // When switching, approximate by formatting with currency symbol from current text.
      const initial = priceEl.textContent?.trim() || '';
      const symbol = initial.replace(/[0-9.,\s]/g, '').slice(0, 3) || '€';
      const value = (Number(cents) / 100).toFixed(2).replace('.', ',');
      return `${symbol}${value}`;
    };

    const setMode = (mode) => {
      buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.bundleToggleMode === mode));

      if (mode === 'subscribe' && Array.isArray(data.plans) && data.plans.length) {
        const plan = data.plans[0];
        sellingPlanInput.value = String(plan.id || '');
        if (plan.price != null) priceEl.textContent = formatMoney(plan.price);
      } else {
        sellingPlanInput.value = '';
        if (data.oneTimePrice != null) priceEl.textContent = formatMoney(data.oneTimePrice);
      }
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => setMode(btn.dataset.bundleToggleMode || 'onetime'));
    });

    setMode('onetime');
  });
})();

